module.exports = __webpack_public_path__ + "img/product_info.c470fd23.svg";